import { render, staticRenderFns } from "./TDropdownActions.vue?vue&type=template&id=657af912&"
import script from "./TDropdownActions.vue?vue&type=script&lang=ts&"
export * from "./TDropdownActions.vue?vue&type=script&lang=ts&"
import style0 from "./TDropdownActions.vue?vue&type=style&index=0&id=657af912&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports